import { render, staticRenderFns } from "./classVideo.vue?vue&type=template&id=5f411f31&scoped=true"
import script from "./classVideo.vue?vue&type=script&lang=js"
export * from "./classVideo.vue?vue&type=script&lang=js"
import style0 from "./classVideo.vue?vue&type=style&index=0&id=5f411f31&prod&lang=scss"
import style1 from "./classVideo.vue?vue&type=style&index=1&id=5f411f31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f411f31",
  null
  
)

export default component.exports